// @flow

import * as React from 'react';

import {
  ChoiceField,
  ChoiceFieldGroup,
  useBasicValidators,
} from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Base, Label, Placeholder, SrOnly } from '@gandi/ui';

import { useMailboxLabel } from 'src/MailboxCreate/hooks';

import { useProductsFetch } from '../../../modules/hooks/useProductsFetch';

const PRODUCTS_PLACEHOLDERS = [
  { config_name: `placeholder-0` },
  { config_name: `placeholder-1` },
];

export function OfferField(): React.MixedElement {
  const { __ } = useTranslator();
  const { required } = useBasicValidators();

  const { summaries } = useProductsFetch();

  const getMailboxLabel = useMailboxLabel();

  const products = !summaries ? PRODUCTS_PLACEHOLDERS : summaries;

  return (
    <>
      {
        // $FlowFixMe[prop-missing]
        <Label aria-hidden>{__('Select an offer')}</Label>
      }
      <ChoiceFieldGroup
        choiceGroupProps={{
          legend: __('Select an offer'),
          layout: 'row',
        }}
        name="config_name"
        validate={required}
      >
        {products.map(product => (
          <ChoiceField
            key={product.config_name}
            name="config_name"
            value={product.config_name}
          >
            <Base slot="label" weight="semibold" transform="capitalize">
              {!product.label ? (
                <>
                  <SrOnly>{__('Loading offers...')}</SrOnly>
                  <Placeholder display="inline-block" chars={15} />
                </>
              ) : (
                getMailboxLabel(
                  product.config_name,
                  product.config_name === 'standard'
                    ? __('10 GB')
                    : __('50 GB'),
                )
              )}
            </Base>
          </ChoiceField>
        ))}
      </ChoiceFieldGroup>
    </>
  );
}
